import CSS from 'csstype'

export const treeView: CSS.Properties = {
    width: "100%"
}